export default "__VITE_ASSET__wlok3ggg__"